'use strict';

import RepoGamComponent from './repo-gam.component';

const DashboardGam = angular
    .module('app.reporte.gam', [])
    .component('appReporteGam', RepoGamComponent)
    .config(($stateProvider) => {
        $stateProvider
            .state('reporte-gam', {
                url: '/reporte-gam',
                component: 'appReporteGam'
            });
    })
    .name;

export default DashboardGam;



// WEBPACK FOOTER //
// ./src/app/components/reportes/reportesGam/repo-gam.module.js